module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/facility-02c14242cadda592e8aac62b5891ef09.webp";